import { render, staticRenderFns } from "./AddOldJobs.vue?vue&type=template&id=5c10ad88&scoped=true"
import script from "./AddOldJobs.vue?vue&type=script&lang=js"
export * from "./AddOldJobs.vue?vue&type=script&lang=js"
import style0 from "./AddOldJobs.vue?vue&type=style&index=0&id=5c10ad88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c10ad88",
  null
  
)

export default component.exports